import { useRef } from "react";

import { FaCamera } from "react-icons/fa";
import { PiCarProfileFill } from "react-icons/pi";
import { compressImage } from "../../../services/imageCompression";

import styles from "./CarImagePicker.module.css";

const CarImagePicker = ({
  formik,
  previewImage,
  setPreviewImage,
}) => {

  const { setFieldValue } = formik;

  const inputRef = useRef(null);

  const openPicker = () => {
    inputRef.current?.click();
  };

  const handleChange = async (e) => {

    const file = e.target.files?.[0];
  
    if (!file) return;
  
    const compressed = await compressImage(file);

    // ✅ ساخت File با نام اصلی
    const fileWithName = new File(
      [compressed], 
      file.name, // یا هر نامی که میخوای
      { 
          type: compressed.type || file.type,
          lastModified: Date.now()
      }
  );
  
    setFieldValue("imageFile", fileWithName);
  
    setPreviewImage(
      URL.createObjectURL(fileWithName)
    );

    e.target.value = "";
  
  };

  return (

    <div className={styles.wrapper}>

      <input
        ref={inputRef}
        hidden
        type="file"
        accept="image/*"
        onChange={handleChange}
      />

      <button
        type="button"
        className={styles.avatarButton}
        onClick={openPicker}
      >

        {

        previewImage  ?
          (
            <img
              src={previewImage}
              alt="خودرو"
              className={styles.image}
            />
          ):(
            <div className={styles.placeholder}>

              <PiCarProfileFill
                className={styles.carIcon}
              />

              <span className={styles.placeholderText}>
                بدون تصویر
              </span>

            </div>

          )

        }

        <span className={styles.cameraButton}>
          <FaCamera />
        </span>

      </button>

      <div className={styles.caption}>

        {
          previewImage 
            ? "تغییر تصویر"
            : "برای انتخاب تصویر لمس کنید"
        }

      </div>

    </div>

  );

};

export default CarImagePicker;